/* MB Machinery */
(function () {
  'use strict';

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Sticky header */
  function stickyHeader() {
    var el = qs('[data-header]');
    if (!el) return;
    function check() { el.classList.toggle('is-stuck', window.scrollY > 8); }
    check();
    window.addEventListener('scroll', check, { passive: true });
  }

  /* Panelen: mobiel menu en zoeken */
  function panels() {
    qsa('[data-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var p = qs('#' + btn.getAttribute('data-open'));
        if (!p) return;
        p.classList.add('is-open');
        p.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var f = p.querySelector('input, button, a');
        if (f) setTimeout(function () { f.focus(); }, 80);
      });
    });
    function sluit(p) {
      if (!p) return;
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    qsa('[data-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        sluit(btn.closest('.drawer, .search-panel'));
      });
    });
    qsa('.drawer__overlay').forEach(function (ov) {
      ov.addEventListener('click', function () { sluit(ov.closest('.drawer')); });
    });
    qsa('.search-panel').forEach(function (p) {
      p.addEventListener('click', function (e) { if (e.target === p) sluit(p); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') qsa('.drawer.is-open, .search-panel.is-open').forEach(sluit);
    });
  }

  /* Galerij op de machinepagina */
  function gallery() {
    qsa('[data-gallery]').forEach(function (g) {
      var hoofd = g.querySelector('[data-gallery-main]');
      if (!hoofd) return;
      g.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]');
        if (!t) return;
        e.preventDefault();
        if (t.dataset.src) hoofd.setAttribute('src', t.dataset.src);
        if (t.dataset.srcset) hoofd.setAttribute('srcset', t.dataset.srcset);
        hoofd.setAttribute('alt', t.dataset.alt || '');
        g.querySelectorAll('[data-thumb]').forEach(function (x) {
          x.setAttribute('aria-current', x === t ? 'true' : 'false');
        });
      });
    });
  }

  /* Filteren en sorteren op de collectiepagina */
  function collectie() {
    qsa('[data-facets-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var w = qs('[data-facets]');
        if (w) w.classList.toggle('is-open');
      });
    });
    qsa('[data-auto-submit]').forEach(function (el) {
      el.addEventListener('change', function () {
        var f = el.closest('form');
        if (f) f.submit();
      });
    });
    qsa('[data-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
  }

  /* Machinenaam uit de link overnemen in het formulier */
  function machineInvullen() {
    var machine = new URLSearchParams(window.location.search).get('machine');
    if (!machine) return;
    var veld = qs('[name="contact[machine]"]');
    if (veld) veld.value = machine;
    var bericht = qs('[name="contact[body]"]');
    if (bericht && !bericht.value) bericht.value = 'Ik heb interesse in: ' + machine + '.\n\n';
    qsa('[data-machine-naam]').forEach(function (el) { el.textContent = machine; });
  }

  /* Animaties bij scrollen */
  function animaties() {
    var els = qsa('[data-anim]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (rijen) {
      rijen.forEach(function (r) {
        if (!r.isIntersecting) return;
        var d = parseInt(r.target.getAttribute('data-anim-delay'), 10) || 0;
        setTimeout(function () { r.target.classList.add('is-in'); }, d);
        io.unobserve(r.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Lopende balk verdubbelen zodat hij naadloos doorloopt */
  function marquee() {
    qsa('[data-marquee]').forEach(function (t) { t.innerHTML = t.innerHTML + t.innerHTML; });
  }

  function start() {
    stickyHeader();
    panels();
    gallery();
    collectie();
    machineInvullen();
    animaties();
    marquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
